"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _EnvironmentProvider = require("./EnvironmentProvider");
Object.keys(_EnvironmentProvider).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _EnvironmentProvider[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _EnvironmentProvider[key];
    }
  });
});
